import { Alert, Stack, Typography } from "@mui/material"
import React from "react"
import { useAppSelector } from "../../../../../app/hooks"
import { EAR_Alerts } from "./EAR_Alerts";
import { EAR_PayerInfo } from "./EAR_PayerInfo";
import { EAR_Procedures } from "./EAR_Procedures";
import { useParams } from "react-router";
import { usePayerDetailsQuery } from "../../../../../services/orgService/org-api";
import { PayerForCenterRequest } from "../../../../../services/orgService/commands";
import { usePrimaryPayerCode } from "../../../hooks/usePrimaryPayerCode";

function ElectronicAuthRetrieval(){
    const {id} = useParams();
    const verification = useAppSelector((state)=>state.verification.verification);
    const payerCode = usePrimaryPayerCode();
    const recId = usePayerDetailsQuery(new PayerForCenterRequest(verification.center, payerCode)).data?.waystarAuthPayer;
    return <React.Fragment>
        {recId === '' &&
            <Alert color='info'>{'Electronic Authorization Retrieval not available for payer ' + (verification.primaryPayerName || '')}</Alert>
        }
        {verification?.waystarAuthStatus != null && 
        <div>
        <Stack marginTop={'15px'} gap={1}>
            <Typography className="psn-green" variant='h6'>Electronic Authorization Retrieval</Typography>
            <EAR_Alerts/>
            <EAR_PayerInfo/>
            <EAR_Procedures/>
        </Stack>
        </div>
        }

    </React.Fragment>
}

export {ElectronicAuthRetrieval}